export default __webpack_public_path__ + "1ad1555122f4d4700d7fccb62b43b485.png";